<template>
  <div class="menulist">
    <transition name="sideUp">
      <div class="content" ref="content" v-show="showMenu">
        <div class="list-wrapper">
          <p class="title">
            {{menuList.title}}
          </p>
          <type-list v-for="(item, index) in menuList.content" :item="item" :index="index" :key="index"
                     :name="item.name" :action="item.action" :icon="item.iconInfo" :clickItem="clickItem"
                     :color="item.color" class="tips-ok"></type-list>
        </div>
        <div class="tips-cancle" @click.stop="hideMenuList">取消</div>
      </div>
    </transition>
    <transition name="sideUp">
      <confirm-tips :tipTitle="tipTitle" :clickCallBack="deleteFile" :tipsType="tipsType"></confirm-tips>
    </transition>
    <transition name="sideUp">
      <confirm-tips :tipTitle="deliveryTip" :clickCallBack="cancelDelivery" :tipsType="deliveryType"></confirm-tips>
    </transition>
    <transition name="fade">
      <div class="mask" v-show="showMenu" @click="hideMenuList" @touchmove.stop.prevent="stopTouch($event)">
      </div>
    </transition>
  </div>
</template>

<script>
  import store from 'store'
  import typelist from './menu_item.vue'
  import tips from 'tips'
  import * as Util from 'util'
  export default {
    data () {
      return {
        isShow: false,
        tipsType: 'confirmDelete',
        tipTitle: '确定删除该文件',
        deliveryTip: '确定要取消外链么？',
        deliveryType: 'confirmDelivery'
      }
    },
    methods: {
      stopTouch (event) {
        return
      },
      clickItem (obj) {
        switch (obj.action) {
          case `preview`:
            store.commit(`setStartPreview`, true)
            this.hideMenuList()
            break
          case 'delivery':
            this.hideMenuList()
            this.$router.push('/delivery')
            break
          case 'cancelDelivery':
            this.hideMenuList()
            store.commit('showConfirmTips', 'confirmDelivery')
            break
          case 'favorite':
            this.hideMenuList()
            store.dispatch('setFavorite', {uid: store.state.userInfo.uid, snapshot: this.$store.getters.getCurrentFile})
            break
          case 'cancelFavorite':
            this.hideMenuList()
            store.dispatch('cancelFavorite', {snapshot: this.$store.getters.getCurrentFile})
            break
          case `rename`:
            console.log('rename')
            store.commit('showRenameDialog')
            this.hideMenuList()
            break
          case `move`:
            console.log('move')
            this.hideMenuList()
            this.$router.push('/movecopy')
            store.commit('setMoveCopyFlag', 'move')
            break
          case `copy`:
            console.log('copy')
            this.hideMenuList()
            this.$router.push('/movecopy')
            store.commit('setMoveCopyFlag', 'copy')
            break
          case `download`:
            console.log('download')
            var params = this.$store.getters.getCurrentFile
            var uri = ''
            if (params.url) {
              uri = params.url + '&token=' + params.token
            } else {
              uri = '/v2/dl_router/databox/' + params.path + '?'
              if (params.path_type) uri += 'path_type=' + params.path_type
              if (params.from) uri += '&from=' + params.from
              if (params.neid) uri += '&neid=' + params.neid
              if (Util.getCookie('S')) {
                uri += '&S=' + Util.getCookie('S')
              }
            }
            uri += '&X-LENOVO-SESS-ID=' + store.state.userInfo['X-LENOVO-SESS-ID']
            uri = encodeURI(uri)
            uri = uri.replace(/#/g, '%23')
            location.href = uri
            this.hideMenuList()
            break
          case `delete`:
            console.log('delete')
            store.commit('showConfirmTips', 'confirmDelete')
            this.hideMenuList()
            break
          case `detail`:
            console.log('detail')
            this.$router.push('/fileDetail')
            this.hideMenuList()
            break
          case `comment`:
            console.log('comment')
            this.$router.push('/comments')
            this.hideMenuList()
            break
          case `history`:
            console.log('history')
            this.$router.push('/history')
            this.hideMenuList()
            break
        }
        console.log(obj.action + '===menuList1==' + obj.type)
//        console.log(menuList.content)
      },
      deleteFile () {
        store.dispatch('deleteFile', {params: this.$store.getters.getCurrentFile})
      },
      cancelDelivery () {
        var params = {
          'codes[]': this.$store.getters.getCurrentFile.delivery_code
        }
        store.dispatch('cancelDelivery', {params: params})
      },
      cancelFavorite () {
      },
      hideMenuList () {
        store.dispatch({
          type: 'hideMenuList'
        })
      }
    },
    computed: {
      showMenu () {
        this.isShow = this.$store.getters.getIsShow ? this.$store.getters.getIsShow : false
        return this.$store.getters.getIsShow ? this.$store.getters.getIsShow : false
      },
      menuList () {
        return this.$store.getters.getShowMenuList
      }
    },
    watch: {
      '$store.state.fileInfo.tipsTitle': function (val, oldVal) {
        this.tipTitle = val
      }
    },
    components: {
      'type-list': typelist,
      'confirm-tips': tips
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/global.styl"
  .menulist
    font-size: 0.4rem
    .content
      position: fixed
      z-index: 16
      height: auto
      bottom: 0
      left: 0
      right: 0
      margin: 0.26rem
      &.sideUp-enter-to, &.sideUp-leave-to
        transition: transform 0.3s
      &.sideUp-enter, &.sideUp-leave-to
        transform: translate3d(0, 100%, 0)
      .list-wrapper
        border-radius: 0.32rem;
        background: #fcfcfc;
        .title
          margin: 0 auto
          width: 9.46rem
          height: 1rem
          line-height: 1rem
          white-space: nowrap
          background:#FCFCFC
          color: $slave_font
          font-size: 0.32rem
          text-align center
          border-radius:.32rem .32rem 0 0
          overflow: hidden
          text-overflow: ellipsis
          word-wrap: normal
        .tips-ok
          border-radius: 0
          color:$primarycolor
          border-top: 1px solid $thin_font;
          background: transparent
</style>



// WEBPACK FOOTER //
// menu_current_file.vue?8e3e81f6